import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  Item,
  ItemActionResult,
  ItemView,
  ItemViewProviderDirective,
  ServerItemAction
} from '@ntap/core';
import { Observable, Subject, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-vrati-predmet-u-obradu-action',
  templateUrl: './vrati-predmet-u-obradu-action.component.html'
})
export class VratiPredmetUObraduActionComponent extends ServerItemAction {
  itemViewProvider: ItemViewProviderDirective<ItemView> = inject(
    ItemViewProviderDirective
  );
  formBuilder: FormBuilder = inject(FormBuilder);
  submitSubject = new Subject<boolean>();
  showDialog = false;

  confirmRejection() {
    this.showDialog = false;
    this.submitSubject.next(true);
  }

  override executeAction(event: any): void {
    this.showDialog = true;
    super.executeAction(event);
  }

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    return this.submitSubject.pipe(
      switchMap(() => {
        return super.doExecuteWithItem(item).pipe(
          tap(() => {
            this.window.close();
          })
        );
      })
    );
  }

  closeDialog() {
    this.showDialog = false;
  }
}
